import React, { FC } from 'react';
import CashAdjustmentEntry, { IEquityFutureFormValues } from './EquityFutureEntry';
import { IAssetEntryComponentProps } from '../types/IAssetEntryComponentProps';
import { IRootState } from '../../../../../../../../services/store';

type Props = IAssetEntryComponentProps<IEquityFutureFormValues>;
type UnconfirmedTrade = IRootState['snapshot']['snapshotEdit']['editedUnconfirmedTrade'];

const EquityFutureEditContainer: FC<Props> = ({ editedUnconfirmedTrade, ...props }) => {
  return (
    <CashAdjustmentEntry editMode={true} {...props} initialValues={getInitialValuesFromTrade(editedUnconfirmedTrade)} />
  );
};

const getInitialValuesFromTrade = (t?: UnconfirmedTrade) => {
  if (typeof t === 'undefined') {
    return {};
  }
  const { instrument, custodian, tradeType, quantity, price, fxRate, operation, currencyDetails, key } = t!.trade;

  const currencyName = currencyDetails?.name ?? '';

  const values: Partial<IEquityFutureFormValues> = {
    ...t.trade,
    instrument,
    currency: {
      id: currencyName,
      value: currencyName,
      name: currencyName,
    },
    custodian,
    key,
    operation: operation as 'BUY' | 'SELL',
    amount: quantity,
    fxRate,
    tradeType,
  };

  return values;
};

export default EquityFutureEditContainer;
